import React from "react";
import imageIcon from "../../assets/images/Oval.png";
import { Switch } from "antd";

const DoctorDetailsCard = ({ item }) => {
  return (
    <div class="card DoctorDetailsCard p-3">
        <div class="row">
        <div class="col-2">
          <img alt="" src={imageIcon} class="DoctorImgOval" />
        </div>
        <div class="col-6 pt-2 pl-4">
          {/* {cardFor === "operator" ? (
            <span class="OperatorName">
              Dr.
              <span class="row OperatorType">Cardiologist</span>
            </span>
          ) : (
            cardFor === "billing" && (
              <span class="Billing-Station-Gro">
                Billing station:
                <span class="row text-style-1">Ground floor</span>
              </span>
            )
          )} */}
          <span class="OperatorName">
            Dr. {item && item.doctorname ? item.doctorname : "Anil Doctor1"}
            <span class="row OperatorType">
              {item && item.doctorstatus ? item.doctorstatus : "Cardiologist"}
            </span>
          </span>
        </div>
        <div class="col-4 pt-2">
          <div className="row pl-4">
            <Switch
              checkedChildren="In"
              unCheckedChildren="Out"
              style={{ width: "55px" }}
            />
          </div>
          {/* {cardFor === "operator" && (
            <span className="operatorRoom">Room:</span>
          )} */}
          <div className="row">
            <span className="operatorRoom">
              Room: {item && item.roomnumber.split(" ")[0]}
              {item && item.roomnumber.split(" ")[1]}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DoctorDetailsCard;
